<template>
    <div class="main-content email-signature">
        <div class="mb-3">
            <h4>My Tools: <span>CREATE YOUR EMAIL SIGNATURE</span></h4>
            <p class="diagonal-lines"></p>
        </div>
        <div class="row" v-if="!generateSignature">
            <div class="col-sm-4">
                <b-form @submit="onSubmit" >
                    <b-form-group>
                        <label>Full Name:</label>
                        <b-form-input
                        v-model="form.name"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group>
                        <label for="">Official Title:</label>
                        <b-form-input
                        v-model="form.title"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group label="COMPANY:" v-slot="{ ariaDescribedby }"  class="company-select">
                        <b-form-radio-group
                            v-model="form.company"
                            :aria-describedby="ariaDescribedby"
                        >
                        <b-form-radio  value="wcpg" >PIP Global Safety</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>

                    <b-form-group>
                        <label for="">Office: <small>ex. +1 (888) 888-8888</small></label>
                        <b-form-input
                        v-model="form.office"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group>
                        <label for="">Mobile: <small>(OPTIONAL)</small></label>
                        <b-form-input
                        v-model="form.phone"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group >
                        <label for="">Email address:</label>
                        <b-form-input
                        v-model="form.email"
                        type="email"
                        required
                        ></b-form-input>
                    </b-form-group>

                    <button type="submit" class="btn-round-red pt9rem">create signature</button>

                </b-form>
            </div>
            <div class="col-sm-6">

            </div>
        </div>
        <div v-else>
            <div class="row mb-4">
                <div class="col-sm-4">
                    <h5>default signature</h5>
                    <section class="sig-layout" id="default-sig" style="color: #111; font-size: 10pt; line-height: 1.2;" @copy="onCopy">
                        <img id="logoImage" width="141" height="47" :src="form.img" alt="company logo">
                        <p style="font-size: 4pt; margin: 4pt 0;"><br></p>
                        <span style="font-size:10pt; font-weight: bold;">{{ form.name }}</span>
                        <br>
                        <span style="font-size:10pt;">{{ form.title }}</span>
                        <br>
                        <span class="sigBorder" style="font-size: 6pt; color: #cd1b00;">___________________________</span>
                        <p style="font-size: 4pt; margin: 4pt 0;"><br></p>
                        <span style="font-size:10pt;"><strong>{{ (form.companyname || '').toUpperCase() }}</strong></span>
                        <br>
                        <span v-if="form.office" style="font-size:10pt;">
                            {{ form.office }} <span style="font-size:6pt;">OFFICE</span>
                        </span>
                        <br v-if="form.office">
                        <span v-if="form.phone" style="font-size:10pt;">
                            {{ form.phone }} <span style="font-size:6pt;">MOBILE</span>
                        </span>
                        <br v-if="form.phone">
                        <span style="font-size:10pt;"><a :href="'mailto:'+form.email" style="color: #111; text-decoration: underline;">{{ form.email }}</a></span>
                        <br>
                        <span style="font-size:10pt;"><a :href="form.companylink" style="color: #111; text-decoration: underline;">{{form.displaycompanylink}}</a> | <a :href="form.link" style="color: #111; text-decoration: underline;">{{form.displaylink}}</a></span>
                    </section>
                    <a href="javascript:void(0);" class="button" @click="copyToClipboard('default-sig')">select signature</a>
                </div>
                <div class="col-sm-4">
                    <h5>reply signature</h5>
                    <section id="reply-sig" class="sig-layout" style="color: #111; line-height: 1.2;" @copy="onCopy">
                        ----------<span style="font-size: 4pt; line-height: 4pt;"><br><br></span>
                        <span style="color:#000; font-size:10pt; font-weight: bold;">{{ form.name }}</span>
                        <br>
                        <span style="font-size:10pt; margin-bottom: 6.4px;">{{ form.title }}</span>
                        <br>
                        <span style="font-size:10pt;"><strong>{{ (form.companyname || '').toUpperCase() }}</strong></span>
                        <br>
                        <span v-if="form.office" style="font-size:10pt;">
                            {{ form.office }} <span style="font-size:6pt;">OFFICE</span>
                        </span>
                        <br v-if="form.office">
                        <span v-if="form.phone" style="font-size:10pt;">
                            {{ form.phone }} <span style="font-size:6pt;">MOBILE</span>
                        </span>
                        <br v-if="form.phone">
                        <span style="font-size:10pt;"><a :href="'mailto:'+form.email" style="color: #111; text-decoration: underline;">{{ form.email }}</a></span>
                    </section>
                    <a href="javascript:void(0);" class="button"  @click="copyToClipboard('reply-sig')">select signature</a>
                </div>

                <div class="col-sm-4">
                    <h5>mobile device signature</h5>
                    <section class="mob-signature" style="font-size:12pt;" id="mob-signature">

                        <span>{{form.name}}</span><br>
                        <span>{{ form.title }}</span><br>
                        <span class="text-uppercase">{{ form.companyname }}</span><br>
                        <span><span v-if="form.office" class="text-uppercase">OFFICE: {{ form.office }}</span> | <span  v-if="form.phone" class="text-uppercase">MOBILE: {{ form.mobile }}</span></span><br>
                        <a :href="'mailto:'+form.email" style="color:#000;">{{form.email}}</a><br>
                        <span>--------</span><br>
                        <span>Please excuse any spelling errors, this message has been sent using my mobile device.</span><br>
                        <span>--------</span><br>


                    </section>
                    <a href="javascript:void(0);" class="button"  @click="copyToClipboard('mob-signature')">select signature</a>
                </div>
            </div>
            <div class="how-to-add-signature mt-4 py-5">
                <div>
                    <h3 class="mb-4">how to add to your signatures to outlook</h3>
                    <div class="row">
                        <div class="col-md-5">
                            <youtube :video-id="'PV10IWGOvic'" ref="youtube" width="100%;"></youtube>
                        </div>
                        <div class="col-md-5">
                            <ul>
                                <li>
                                    <strong>step 1:</strong>
                                    <span>SELECT the signature, RIGHT-CLICK, CLICK "Copy". <b-button v-b-modal.email-modal-1 class="show-button">SHOW ME?</b-button></span>
                                    <i>If you would like a signature without the PIP logo for non-html email services, DO NOT SELECT IT.</i>


                                    <b-modal id="email-modal-1"   hide-footer>
                                    <img src="/images/email-sig-step-1.jpg" alt="draft">
                                    </b-modal>
                                </li>
                                <li>
                                    <strong>step 2:</strong>
                                    <span>OPEN Microsoft Outlook</span>
                                </li>
                                <li>
                                    <strong>step 3:</strong>
                                    <span>CLICK "File", CLICK "Options". <b-button v-b-modal.email-modal-2 class="show-button">SHOW ME?</b-button></span>

                                    <b-modal id="email-modal-2"   hide-footer>
                                    <img src="/images/email-sig-step-3.jpg" alt="draft">
                                    </b-modal>
                                </li>
                                <li>
                                    <strong>step 4:</strong>
                                    <span>CLICK "Mail", CLICK "Signatures". <b-button v-b-modal.email-modal-3 class="show-button">SHOW ME?</b-button></span>

                                    <b-modal id="email-modal-3"   hide-footer>
                                    <img src="/images/email-sig-step-4.jpg" alt="draft">
                                    </b-modal>
                                </li>
                                <li>
                                    <strong>step 5:</strong>
                                    <span>CLICK "New". <b-button v-b-modal.email-modal-4 class="show-button">SHOW ME?</b-button></span>

                                    <b-modal id="email-modal-4"   hide-footer>
                                    <img src="/images/email-sig-step-5.jpg" alt="draft">
                                    </b-modal>
                                </li>
                                <li>
                                    <strong>step 6:</strong>
                                    <span>Name your signature and CLICK "OK". <b-button v-b-modal.email-modal-5 class="show-button">SHOW ME?</b-button></span>

                                    <b-modal id="email-modal-5"   hide-footer>
                                    <img src="/images/email-sig-step-6.jpg" alt="draft">
                                    </b-modal>
                                </li>
                                <li>
                                    <strong>step 7:</strong>
                                    <span>RIGHT-CLICK in the "Edit Signature" box, CLICK "Paste" (Keep Source Formatting). <b-button v-b-modal.email-modal-6 class="show-button">SHOW ME?</b-button></span>

                                    <b-modal id="email-modal-6"   hide-footer>
                                    <img src="/images/email-sig-step-7.jpg" alt="draft">
                                    </b-modal>
                                </li>
                                <li>
                                    <strong>step 8:</strong>
                                    <span>CLICK "OK"...DONE! <b-button v-b-modal.email-modal-7 class="show-button">SHOW ME?</b-button></span>

                                    <b-modal id="email-modal-7"   hide-footer>
                                    <img src="/images/email-sig-step-8.jpg" alt="draft">
                                    </b-modal>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import validationErrors from "../mixins/validationErrors";
export default {
    mixins: [validationErrors],
    data() {
        return {
            loading: false,
            route: null,
            success:false,
            generateSignature:false,
        };
    },

    computed: {
        ...mapState({ user: state => state.user }),
        form(){

            return {
                'name': this.user.f_name+' '+this.user.l_name,
                'title': this.user.title + ', PIP Retail',
                'company': 'wcpg',
                'office':this.user.phone,
                'mobile':'',
                'email':this.user.email
            };
        }
    },

    methods:{
        onSubmit(){
            this.generateSignature=true;
            switch(this.form.company){
                case "wcpg":
                    this.form.img="https://us.pipglobal.com/images/signatures/divisions/Sig-DIvision-Logo_PIP-Global-Safety-old.png";
                    this.form.companyname="PIP Global Safety";
                    this.form.companylink="https://www.pipretail.com";
                    this.form.displaycompanylink="www.pipretail.com";

                break;
            }
            this.form.link="https://www.pipglobalsafety.com";
            this.form.displaylink="www.pipglobalsafety.com";
        },
        onCopy(e){
            // Browser-serialized selections drop nested inline styles; send the authored markup instead.
            const html = e.currentTarget.outerHTML.replace(/<!--[\s\S]*?-->/g, '');
            e.clipboardData.setData('text/html', html);
            e.clipboardData.setData('text/plain', e.currentTarget.innerText);
            e.preventDefault();
        },
        copyToClipboard(element){
            var range;
            if (document.selection) { // IE
                range = document.body.createTextRange();
                range.moveToElementText(document.getElementById(element));
                range.select();
            } else if (window.getSelection) {
                range = document.createRange();
                range.selectNodeContents(document.getElementById(element));
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
            }

            try {
                document.execCommand('copy');
                console.log('Text copied to clipboard');
            } catch (error) {
                console.log('Unable to copy text to clipboard:', error);
            }
        }
    }
}
</script>
